<template>
    <div>
        <b-form-group
            label="Default locale:"
            label-for="defaultLocale"
            :label-cols="3"
            :horizontal="true">
            <v-select :options="availableLocales" v-model="constraints.custom_data.texti18n.default_locale"></v-select>
        </b-form-group>
    </div>
</template>
<script>
import vSelect from 'vue-select'
import locales from '@/components/identityFields/locales.json'

export default {
    components: {
        vSelect
    },
    props: {
        value: {
            type: Object | Array,
            default: function() {
                return null
            }
        }
    },
    data: function() {
        return {
            showEditor: false
        }
    },
    computed: {
        constraints: {
            get() {
                let base = this.value
                let {custom_data = {}} = base
                let {texti18n} = custom_data

                if (!texti18n) {
                    custom_data.texti18n = {
                        default_locale: "en_US"
                    }
                }

                return base;
            },

            set(val) {
                this.$emit('input', val)
            }
        },

        availableLocales() {
            return Object.keys(locales)
        }
    },
    methods: {
        
    }
    
}
</script>